import { ConfigurationSourceDataMap, CoordinatingGroup, Institution, MasterGroup, Metadata, Participant, SourceData, Trial } from "@/api/dtos";
import ParticipantSourceDataFormStatusList from "@/components/lists/status/ParticipantSourceDataFormStatusList";
import ParticipantSourceDataFormStatusesContext from "@/contexts/data/ParticipantSourceDataFormStatusesContext";
import SourceDataFormContext from "@/contexts/form/SourceDataFormContext";
import useForms from "@/hooks/form/source-data/useForms";
import { FC, useContext, useMemo } from "react";

interface ISourceDataFormsProps {
    trial: Trial;
    masterGroup?: MasterGroup;
    coordinatingGroup?: CoordinatingGroup;
    institution?: Institution;
    participant: Participant;
    metadata: Metadata;
    trialConfiguration: ConfigurationSourceDataMap;
    configuration: ConfigurationSourceDataMap;
    sourceData: SourceData;
    studyEventOid: string;
    studyEventRepeat: number;
    preview?: boolean;
}

const SourceDataForms: FC<ISourceDataFormsProps> = ({
    trial,
    masterGroup,
    coordinatingGroup,
    institution,
    participant,
    metadata,
    trialConfiguration,
    configuration,
    sourceData,
    studyEventOid,
    studyEventRepeat,
    preview
}) => {
    const { idMap: formStatusMapping, refresh: statusesRefresh } = useContext(ParticipantSourceDataFormStatusesContext);
    const {  queueUpdate } = useContext(SourceDataFormContext);
    
    const statusMapping = useMemo(() => {
        return formStatusMapping?.[studyEventOid]?.[studyEventRepeat]
    }, [formStatusMapping, studyEventOid, studyEventRepeat])
    
    const formData = useForms(
        metadata,
        trialConfiguration,
        configuration,
        sourceData,
        trial,
        masterGroup,
        coordinatingGroup,
        institution,
        participant,
        studyEventOid,
        studyEventRepeat,
        preview
    );

    return (
        <>
            <ParticipantSourceDataFormStatusList 
                trial={trial}
                institution={institution}
                participant={participant}
                data={formData}
                statuses={statusMapping}
                queueUpdate={queueUpdate}
            />
        </>
    )
};

export default SourceDataForms;